import ImageCompare from "image-compare-viewer";
import 'image-compare-viewer/dist/image-compare-viewer.min.css';
import $ from 'jquery';

const options = {
    // UI Theme Defaults
  
    controlColor: "#FFFFFF",
    controlShadow: true,
    addCircle: true,
    addCircleBlur: false,
  
    // Label Defaults
  
    showLabels: true,
    labelOptions: {
      before: 'PRZED',
      after: 'PO',
      onHover: false
    },
  
    // Smoothing
  
    smoothing: false,
  
    // Other options
  
    hoverStart: false,
    verticalMode: false,
    startingPoint: 50,
    fluidMode: false
  };
  
  
window.addEventListener('DOMContentLoaded', () => {
    const viewers = document.querySelectorAll(".image-compare");
    viewers.forEach((element) => {
      let view = new ImageCompare(element, options).mount();
    });
    $('.surgeries').fadeIn(1000).removeClass('hidden');

});




